import { render, staticRenderFns } from "./RecentInfiniteListToQuote.vue?vue&type=template&id=f0d97f16&scoped=true&lang=pug&"
import script from "./RecentInfiniteListToQuote.vue?vue&type=script&lang=js&"
export * from "./RecentInfiniteListToQuote.vue?vue&type=script&lang=js&"
import style0 from "./RecentInfiniteListToQuote.vue?vue&type=style&index=0&id=f0d97f16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d97f16",
  null
  
)

export default component.exports